import { CHANGE_PASSWORD_SUBMIT_SUCCESS } from 'src/common/constants/localizations/settings';
import ActionSuccessAlert from '../../shared/alerts/ActionSuccessAlert';

const ChangePasswordSuccess = () => (
  <div data-testid="changePasswordSuccess">
    <ActionSuccessAlert
      key="changePasswordSuccess"
      localizedText={CHANGE_PASSWORD_SUBMIT_SUCCESS}
    />
  </div>
);

export default ChangePasswordSuccess;
